<template>
  <div class="location"></div>
</template>

<script>
import geolocator from 'geolocator'
import geolib from 'geolib'

var locationWatcher = false

export default {
  name: 'location',
  data () {
    return {
      firstTime: true
    }
  },
  computed: {
    userLocation () {
      return this.$store.state.userLocation
    },
    locationError () {
      return this.$store.state.locationError
    },
    areas () {
      return this.$store.state.areas
    },
    currentArea () {
      return this.$store.state.currentArea
    }
  },
  methods: {
    watchLocation () {
      locationWatcher = geolocator.watch({
        enableHighAccuracy: true,
        timeout: 5000,
        maximumWait: 10000,
        maximumAge: 0,
        desiredAccuracy: 1,
        fallbackToIP: false,
        addressLookup: false,
        timezone: false
      }, (err, location) => {
        if (err) {
          this.$store.commit('changeLocationError', true)
          return console.log(err)
        }
        this.$store.commit('changeLocationError', false)
        var userLocation = {
          lat: location.coords.latitude,
          lng: location.coords.longitude
        }
        this.$store.commit('changeUserLocation', userLocation)
        //  console.log('commited a userLocation change')
        window.setTimeout(() => {
          this.$store.commit('setLocationHasBeenLoaded', true)
        }, 4000)
      })
    },
    setupGeolocation () {
      geolocator.config({
        language: 'en',
        google: {
          version: '3',
          key: 'AIzaSyBP498t5dAbPMm_x9CsRzGxSK_wrtZtOnc'
        }
      })
    },
    checkUserCurrentArea () {
      for (var i = 0; i < this.areas.length; i++) {
        var areaName = this.areas[i].key
        let areaTalkName = this.areas[i].name
        var point = {
          latitude: this.userLocation.lat,
          longitude: this.userLocation.lng
        }
        var polygon = this.areas[i].coordinates.map((a) => {
          var coordinate = {
            latitude: a.lat,
            longitude: a.lng
          }
          return coordinate
        })
        var isinside = geolib.isPointInside(point, polygon)
        if (isinside) {
          this.$store.commit('setCurrentAreaName', areaTalkName)
          this.$store.commit('setCurrentArea', areaName)
          /* this.$store.dispatch('addNotice', {
            text: 'You entered ' + areaName,
            user: this.$store.state.user.uid,
            type: 'location'
          }) */
          return true
        }
      }
      this.$store.commit('setCurrentArea', null)
    }
  },
  mounted () {
    this.watchLocation()
    //  this.$store.dispatch('populateAreasFromJson')
    //  this.$store.dispatch('populateSpots')
  },
  watch: {
    userLocation (val) {
      this.checkUserCurrentArea()
      //  google.maps.geometry.poly.containsLocation(e.latLng, bermudaTriangle)
    },
    areas () {
      this.checkUserCurrentArea()
    },
    currentArea (val, oldVal) {
      if (oldVal === null && val !== null) {
        if (!this.firstTime || this.$route.path === '/map') {
          this.firstTime = false
          let areaName = this.$store.state.currentAreaName
          if (this.$store.state.locationHasBeenLoaded || this.$store.state.hasBeenToStart) {
            if (this.$route.path === '/map') {
              this.$store.commit('interupt', 'Du har tagit dig till fotoområdet ' + areaName + '! <h6>Sätt på dina AR-glasögon för att hitta de fem fotoplatserna i området. AR-glasögonen finns i din kameraväska.</h6>')
            }
          }
        }
      }
      this.$store.dispatch('fetchSpots', {areaKey: val})
    }
  },
  beforeDestroy () {
    if (locationWatcher !== false) {
      locationWatcher.clear()
    }
  }
}
</script>
<style scoped>
/* Compass by Richard Schumann from the Noun Project */
</style>



// WEBPACK FOOTER //
// Location.vue?f970d20e